/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FailItem } from './FailItem';
import {
    FailItemFromJSON,
    FailItemFromJSONTyped,
    FailItemToJSON,
    FailItemToJSONTyped,
} from './FailItem';

/**
 * 
 * @export
 * @interface BonusBatchGrantResultVo
 */
export interface BonusBatchGrantResultVo {
    /**
     * 总人数（去重后）
     * @type {number}
     * @memberof BonusBatchGrantResultVo
     */
    totalCount?: number;
    /**
     * 成功人数
     * @type {number}
     * @memberof BonusBatchGrantResultVo
     */
    successCount?: number;
    /**
     * 失败人数
     * @type {number}
     * @memberof BonusBatchGrantResultVo
     */
    failCount?: number;
    /**
     * 失败明细列表
     * @type {Array<FailItem>}
     * @memberof BonusBatchGrantResultVo
     */
    failItems?: Array<FailItem>;
}

/**
 * Check if a given object implements the BonusBatchGrantResultVo interface.
 */
export function instanceOfBonusBatchGrantResultVo(value: object): value is BonusBatchGrantResultVo {
    return true;
}

export function BonusBatchGrantResultVoFromJSON(json: any): BonusBatchGrantResultVo {
    return BonusBatchGrantResultVoFromJSONTyped(json, false);
}

export function BonusBatchGrantResultVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusBatchGrantResultVo {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'successCount': json['successCount'] == null ? undefined : json['successCount'],
        'failCount': json['failCount'] == null ? undefined : json['failCount'],
        'failItems': json['failItems'] == null ? undefined : ((json['failItems'] as Array<any>).map(FailItemFromJSON)),
    };
}

export function BonusBatchGrantResultVoToJSON(json: any): BonusBatchGrantResultVo {
    return BonusBatchGrantResultVoToJSONTyped(json, false);
}

export function BonusBatchGrantResultVoToJSONTyped(value?: BonusBatchGrantResultVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'successCount': value['successCount'],
        'failCount': value['failCount'],
        'failItems': value['failItems'] == null ? undefined : ((value['failItems'] as Array<any>).map(FailItemToJSON)),
    };
}

